import { MaybeRefOrGetter, toValue } from 'vue'
import { SiteID } from '../../sites/models/site'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useEventStore } from '../../common/eventStore'
import { shiftKeys } from './useShift'
import { copy, ShiftCopyForm } from '../shiftService'

export function useShiftCopyMutation(siteId: MaybeRefOrGetter<SiteID>) {
    const queryClient = useQueryClient()
    const eventStore = useEventStore()

    return useMutation<void, Error, { form: ShiftCopyForm }>({
        mutationFn: async (shiftUpdate) => {
            return copy(toValue(siteId), shiftUpdate.form)
        },
        onSettled: async () => {
            return await queryClient.invalidateQueries({ queryKey: shiftKeys.lists() })
        },
        onSuccess: async () => {
            eventStore.addUpdateToast({ summary: 'Shifts copied', detail: undefined, severity: 'success' })
        },
        onError: async (error) => {
            eventStore.addErrorToast({ detail: error.message })
        },
    })
}